import { render, staticRenderFns } from "./Cargar_anexo.vue?vue&type=template&id=6dc2bbcc&"
import script from "./Cargar_anexo.vue?vue&type=script&lang=js&"
export * from "./Cargar_anexo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports